import { toast } from "react-toastify";
import { CalculateFinalPrice } from "../metadata/CalculatePrice";

export function GetCampaignBonus(services, masters, catalog) {
  try {
    if (!Array.isArray(services) || services.length === 0) return 0;

    return services.reduce((total, service) => {
      const plan = service?.planServicio?.name;
      //const months = service?.duracionContrato || 1;
      const months = service?.numeroItems || 1;

      // Buscar regla
      const rule = masters.find(
        (r) =>
          r.category === "ADS" &&
          r.plan === plan &&
          String(r.months) === String(months)
      );

      // Calcular precio real
      const finalPrice = CalculateFinalPrice(service, catalog);

      // Si hay porcentaje
      const percentageCommission = rule?.percentage
        ? (rule.percentage / 100) * finalPrice
        : 0;

      // Combinamos fijo + porcentaje si ambos existen (o elegí uno)
      const fixed = Number(rule?.fixedCommission) || 0;

      const commission = fixed + percentageCommission;

      return total + commission;
    }, 0);
  } catch (e) {
    toast.error("Error calculando el bono de campañas: " + e);
    return 0;
  }
}
